<template>
  <div class="top-contianer">
    <div class="main_header">
      <h1 style="width: 80%; margin: auto;color: #00264a;">We’d love to hear from you</h1>
      <h5
        class="tips"
      >Whether you have a question about products, courses, pricing, need help, or anything else, our team is ready to answer all your questions</h5>
      <br />
      <br />
      <div class="gmail button">
        <i class="icon">
          <i class="fa fa-google"></i>
        </i>
        <div class="slide">
          <p>Email Us Now!</p>
        </div>
        <div style="position:relative !important; top: 20% !important;">
          <a href="mailto:info@vortex-co.com">info@vortex-co.com</a>
        </div>
      </div>
      <br />
      <br />
      <br />
    </div>
    <GearsSep />
    <b-container id="social_button_container" class="container_sb">
      <b-row class="this_row">
        <b-col class="justify_in_row">
          <div class="facebook button">
            <i class="icon">
              <i class="fa fa-facebook"></i>
            </i>
            <div class="slide">
              <p>Our Page</p>
            </div>
            <a href="https://www.facebook.com/vortexroboticsegypt/">Vortex Robotics</a>
            <div style="position:relative !important; left:-13%; top: -25% !important;">
              <iframe
                src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fvortexroboticsegypt%2F&width=62&layout=button&action=like&size=large&show_faces=false&share=false&height=65&appId=147915585232224"
                width="62"
                height="65"
                style="border:none;overflow:hidden"
                scrolling="no"
                frameborder="0"
                allowtransparency="true"
              ></iframe>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="youtube button">
            <i class="icon">
              <i class="fa fa-youtube"></i>
            </i>
            <div class="slide">
              <p>Subscribe</p>
            </div>
            <a
              style="width:100%; display: block;"
              href="https://www.youtube.com/channel/UC9NpCNSHz5B3BiXDqfqXrYg"
            >Vortex Robotics</a>
            <div
              style="position:relative !important; top: 20% !important;"
              class="g-ytsubscribe"
              data-channelid="UC9NpCNSHz5B3BiXDqfqXrYg"
              data-layout="default"
              data-count="hidden"
            ></div>
          </div>
        </b-col>
        <b-col>
          <div class="linkedin button">
            <i class="icon">
              <i class="fa fa-linkedin"></i>
            </i>
            <div class="slide">
              <p>Connect</p>
            </div>
            <div style="position:relative !important; top: 20% !important;">
              <a href="https://www.linkedin.com/company/35717487">Vortex Robotics</a>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="google button">
            <i class="icon">
              <i class="fa">&#xf095;</i>
            </i>
            <div class="slide">
              <p>Call us</p>
            </div>
            <a
              style="position:relative; top: 20%;"
              href="tel:+201116997475"
            >+20&nbsp; 3&nbsp; 5230010</a>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div id="maprouter" class="mapouter">
      <div class="gmap_canvas">
        <b>30 Qerdahy Street Kafr Abdou Alexandria, Alexandria Governorate, Egypt 21529</b>
        <iframe
          width="600"
          height="271"
          id="gmap_canvas"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3411.811058413435!2d29.952166864841757!3d31.22596361874512!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f5c514fea8d5b9%3A0x81bccf5c265919d5!2sVortex%20Robotics!5e0!3m2!1sen!2seg!4v1609510186246!5m2!1sen!2seg"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
        ></iframe>
        <a href="https://www.embedgooglemap.net/blog/best-wordpress-themes/"></a>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br id="t" />
    <b-container>
      <b-row>
        <b-col>
          <div id="contact-form" class="contact-form">
            <h1 v-if="isSending == 0" class="contact-form_title">Get in touch with us</h1>
            <h1 v-if="isSending == 1" class="contact-form_title">Sending your message..</h1>
            <h1 v-if="isSending == 2" class="contact-form_title">Sent! Thank you, will reply asap.</h1>
            <h1 v-if="isSending == 3" class="contact-form_title">Share with us again</h1>
            <div class="separator"></div>
            <form
              id="feedback"
              action="https://formspree.io/xeqrjank"
              target="_blank"
              method="POST"
              class="form"
            >
              <input
                id="namee"
                required
                name="name"
                v-model="contact.name"
                placeholder="Name"
                type="text"
                autocomplete="off"
              />
              <input
                id="eemail"
                required
                name="email"
                v-model="contact.email"
                placeholder="E-mail"
                type="email"
                autocomplete="off"
              />
              <input
                id="organization"
                name="organization"
                v-model="contact.organization"
                placeholder="Organization/Entity"
                type="text"
                autocomplete="off"
              />
              <input
                id="phone"
                name="phone"
                required
                v-model="contact.phone"
                placeholder="Phone number"
                type="phone"
                autocomplete="off"
              />
              <select id="topic" v-model="contact.topic" name="topic">
                <option value="Other">Other - (Choose a topic)</option>
                <option value="Courses">Vortex Academy</option>
                <option value="Industrial">ROV Commercial Services</option>
                <option value="Quotation">Service Quotation</option>
                <option value="Store">Store Item</option>
                <option value="feedback">Feedback</option>
                <option value="Question">Question</option>
              </select>
              <textarea
                id="subject"
                name="subject"
                v-model="contact.subject"
                rows="1"
                placeholder="Subject"
              ></textarea>
              <textarea
                id="messagee"
                name="message"
                v-model="contact.message"
                rows="12"
                placeholder="Message"
              ></textarea>
              <div style="width:100%; ">
                <button type="submit" class="button">Send</button>
              </div>
            </form>
          </div>
        </b-col>
        <b-col style="padding: 50px 0px 50px;">
          <div style="display: inline-block; width: 100%;">
            <iframe
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fvortexroboticsegypt%2F&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=147915585232224"
              data-width="340"
              width="340"
              height="400"
              style="border:none;overflow:hidden"
              scrolling="no"
              frameborder="0"
              allowtransparency="true"
              allow="encrypted-media"
            ></iframe>
          </div>
        </b-col>
      </b-row>
      <!--<b-row>
                <div id="theForm" class="row">
                    <div class="col-md-8 offset-md-2">
                    <iframe src="https://docs.google.com/forms/d/1DXG2QEGHMyswhwPyzHEQDXAAApTVHo9ZHB7eOBpIOek/viewform?edit_requested=true" width="760" height="500" frameborder="0" marginheight="0" marginwidth="0" id="gform">Loading...</iframe>
                    </div>
                </div>
      </b-row>-->
    </b-container>
  </div>
</template>

<script>
//v-on:submit.prevent="onSubmit" inside form tag
import GearsSep from "./../components/GearsSep.vue";
import { setTimeout } from "timers";
import StoreItemsVue from "../components/StoreItems.vue";
export default {
  name: "ContactUs",
  components: {
    GearsSep
  },

  mounted() {
    var tabs = document.getElementById("right_nav").querySelectorAll("a");
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].style.color = "#00264a";
    }
    document
      .getElementById("vortexNameImage")
      .setAttribute("src", "img/logos/vortex_name.png");
    var po = document.createElement("script");
    po.type = "text/javascript";
    po.async = true;
    po.src = "https://apis.google.com/js/platform.js";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(po, s);

    !(function(d, s, id) {
      var js;
      var fjs = d.getElementsByTagName(s)[0];
      var p = /^http:/.test(d.location) ? "http" : "https";
      if (!d.getElementById(id)) {
        js = d.createElement(s);
        js.id = id;
        js.src = p + "://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
      }
    })(document, "script", "twitter-wjs");

    function onYtEvent(payload) {
      if (payload.eventType == "subscribe") {
        // Add code to handle subscribe event.
      } else if (payload.eventType == "unsubscribe") {
        // Add code to handle unsubscribe event.
      }
      if (window.console) {
        window.console.log("YT event: ", payload);
      }
    }
  },
  data() {
    return {
      entries: null,
      contact: {
        name: "",
        email: "",
        phone: "",
        organization: "",
        message:
          this.$route.params.type == 1
            ? "Item Id : " +
              this.$route.params.id +
              "\nItem Name : " +
              this.$route.params.name +
              "\nQuantity : 1"
            : this.$route.params.type == 2
            ? "Hello,\n\nI would like to request a quotation for the service (" +
              this.$route.params.name +
              ").\n\n-Service Related Information- (Kindly Fill the fields)\n---------------------------------------------------\nExpected Date: XX-XX-XXXX\nDuration: XX (Hours/Days)\nLocation: GOV, COUNTRY."
            : "",
        subject:
          this.$route.params.type == 1
            ? "Reserve please!"
            : this.$route.params.type == 2
            ? "Quotation for a " + this.$route.params.name + " service."
            : "",
        topic:
          this.$route.params.type == 1
            ? "Store"
            : this.$route.params.type == 2
            ? "Quotation"
            : "Other"
      },
      isSending: 0
    };
  },

  methods: {
    clearForm() {
      // this.contact.name = '';
      // this.contact.email = '';
      this.contact.message = "";
      this.contact.subject = "";
      this.contact.organization = "";
      this.contact.topic = "Other";
    },
    onSubmit() {
      this.isSending = 1;
      document.getElementById("namee").style.backgroundColor = "#f2f2f2";
      document.getElementById("eemail").style.backgroundColor = "#f2f2f2";
      document.getElementById("organization").style.backgroundColor = "#f2f2f2";
      document.getElementById("messagee").style.backgroundColor = "#f2f2f2";
      document.getElementById("subject").style.backgroundColor = "#f2f2f2";
      document.getElementById("topic").style.backgroundColor = "#f2f2f2";
      setTimeout(() => {
        this.isSending = 2;
        setTimeout(() => {
          this.clearForm();
          document.getElementById("topic").style.backgroundColor = "#ffffff";
          document.getElementById("subject").style.backgroundColor = "#ffffff";
          document.getElementById("organization").style.backgroundColor =
            "#ffffff";
          document.getElementById("namee").style.backgroundColor = "#ffffff";
          document.getElementById("eemail").style.backgroundColor = "#ffffff";
          document.getElementById("messagee").style.backgroundColor = "#ffffff";
          this.isSending = 3;
        }, 3000);
      }, 1000);
      /* setTimeout(() => {
				// Build for data
				let form = new FormData();
				for (let field in this.contact) {
					form.append(field, this.contact[field]);
				}

				// Send form to server
				this.$http.post('/app.php', form).then((response) => {
					console.log(response);
					this.clearForm();
					this.isSending = false;
				}).catch((e) => {
					console.log(e)
				});

			}, 4000); */
    }
  }
};
</script>

<style lang="scss" scoped>
.top-contianer {
  width: 100%;
}

.container_sb {
  max-width: 100%;
  padding: 0px 200px 0px 200px;
}

.loading {
  height: 50px;
  width: 100px;
}
html,
body {
  min-height: 100%;
}
.justify_in_row {
  text-align: center;
}
select option[value="Other"] {
  color: grey;
}
select {
  margin-bottom: 15px;
}
.tips {
  color: darkgrey;
  width: 50%;
  display: inline-block;
}
.entry {
  min-height: 350px;
  border: 1px solid;
}
#customBtn {
  display: inline-block;
  background: white;
  color: #444;
  width: 190px;
  border-radius: 5px;
  border: thin solid #888;
  box-shadow: 1px 1px 1px grey;
  white-space: nowrap;
}
#customBtn:hover {
  cursor: pointer;
}
span.label {
  font-family: serif;
  font-weight: normal;
}
span.icon {
  background: url("/identity/sign-in/g-normal.png") transparent 5px 50%
    no-repeat;
  display: inline-block;
  vertical-align: middle;
  width: 42px;
  height: 42px;
}
span.buttonText {
  display: inline-block;
  vertical-align: middle;
  padding-left: 42px;
  padding-right: 42px;
  font-size: 14px;
  font-weight: bold;
  /* Use the Roboto font that is loaded in the <head> */
  font-family: "Roboto", sans-serif;
}

#blog {
  margin-bottom: 3em;
}
.mapouter {
  padding: 30px 30px;
  display: inline-block;
  position: relative;
  height: 271px;
  width: 80%;
}
.gmap_canvas {
  left: 0%;
  background-image: url("../../public/img/map.png");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
  background-color: #c3ecb2 !important;
  height: 400px;
  padding: 65px 0px 0px 0px;
}
body {
  background-image: linear-gradient(
      45deg,
      rgba(194, 233, 221, 0.5) 1%,
      rgba(104, 119, 132, 0.5) 100%
    ),
    linear-gradient(-45deg, #494d71 0%, rgba(217, 230, 185, 0.5) 80%);
  margin: 0;
}

#buttons {
  padding: 2px 2px;
  width: 330px;
  overflow: hidden;
}
.button {
  background: #dce0e0;
  position: relative;
  display: inline-block;
  height: 50px;
  margin: 4px;
  overflow: hidden;
  width: 200px;
  border-radius: 3px;
  -o-border-radius: 3px;
  -ms-border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
}
.fb-page,
.fb-page span,
.fb-page span iframe[style] {
  width: 100% !important;
}
.icon {
  display: block;
  float: left;
  position: relative;
  z-index: 3;
  height: 100%;
  width: 38px;
  -moz-border-radius-topleft: 3px;
  -moz-border-radius-topright: 0px;
  -moz-border-radius-bottomright: 0px;
  -moz-border-radius-bottomleft: 3px;
  -webkit-border-radius: 3px 0px 0px 3px;
  border-radius: 3px 0px 0px 3px;
  text-align: center;
}
.icon i {
  color: #fff;
  line-height: 42px;
}
.slide {
  z-index: 2;
  display: block;
  margin: 0;
  height: 100%;
  left: 38px;
  position: absolute;
  width: 163px;
  -moz-border-radius-topleft: 0px;
  -moz-border-radius-topright: 3px;
  -moz-border-radius-bottomright: 3px;
  -moz-border-radius-bottomleft: 0px;
  -webkit-border-radius: 0px 3px 3px 0px;
  border-radius: 0px 3px 3px 0px;
}
.slide p {
  border-left: 1px solid #fff;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
  color: #fff;
  font-size: 18px;
  left: 0;
  margin: 0;
  position: absolute;
  text-align: center;
  top: 10px;
  width: 100%;
}
.button .slide {
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}
.facebook iframe {
  display: block;
  position: absolute;
  right: 23px;
  top: 10px;
  z-index: 1;
}
.twitter iframe {
  width: 90px !important;
  right: 5px;
  top: 10px;
  z-index: 1;
  display: block;
  position: absolute;
}
.google #___follow_0 {
  width: 70px !important;
  top: 10px;
  right: 45px;
  position: absolute;
  display: block;
  z-index: 1;
}
.youtube #___ytsubscribe_0 {
  top: 10px;
  right: 1px;
  position: absolute;
  display: block;
  z-index: 1;
}
.facebook:hover .slide {
  left: 220px;
}
.twitter:hover .slide {
  top: -40px;
}
.google:hover .slide {
  bottom: -50px;
}
.gmail:hover .slide {
  bottom: -50px;
}
.youtube:hover .slide {
  left: -210px;
}
.linkedin:hover .slide {
  left: -210px;
}
.facebook .icon,
.facebook .slide {
  background: #305c99;
}
.linkedin .icon,
.linkedin .slide {
  background: #006599;
}

.gmail .icon,
.gmail .slide {
  background: purple;
}

.twitter .icon,
.twitter .slide {
  background: #00cdff;
}
.google .icon,
.google .slide {
  background: #7ea91b;
}
.youtube .icon,
.youtube .slide {
  background: #b31217;
}

.contact-form {
  font-family: 16px;
  margin: 0 auto;
  padding: 15px 15px 15px;
  max-width: 700px;
  width: 100%;
}
.contact-form .separator {
  border-bottom: solid 1px #ccc;
  margin-bottom: 15px;
}
.contact-form .form {
  display: flex;
  flex-direction: column;
  font-size: 16px;
}
.contact-form_title {
  color: #333;
  text-align: left;
  font-size: 28px;
}
.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form input[type="phone"],
.contact-form textarea {
  border: solid 1px #e8e8e8;
  font-family: "Roboto", sans-serif;
  padding: 10px 7px;
  margin-bottom: 15px;
  outline: none;
}
.contact-form textarea {
  resize: none;
}
.contact-form .button {
  background: #367ee7;
  border: solid 1px #1663d7;
  color: white;
  cursor: pointer;
  padding: 10px 50px;
  text-align: center;
  text-transform: uppercase;
}
.contact-form .button:hover {
  background: #1963d7;
  border: solid 1px #1963d7;
}
.contact-form input[type="email"],
.contact-form input[type="text"],
.contact-form textarea,
.contact-form .button {
  font-size: 15px;
  border-radius: 3px;
}
#social_button_container {
  margin: 50px 0px 0px;
}
@media screen and (max-width: 683px) {
  .container_sb {
    padding: 0px 50px 0px 50px;
  }
}
@media screen and (max-width: 500px) {
  .this_row {
    display: inline-block !important;
  }
  .this_row {
    position: relative;
    left: -30%;
  }
  .tips {
    width: 90%;
  }
  .container_sb {
    padding: 0px 0px 0px 0px;
  }
  .container_sb {
    position: relative;
    left: 30%;
  }
  /*#social_button_container {
        margin: 50px 100px 0px;
    }*/
}
</style>
